import { cn } from '../../lib/utils';

export function Table({ className, children }) {
  return (
    <div className="w-full overflow-x-auto">
      <table className={cn('w-full caption-bottom text-sm', className)}>{children}</table>
    </div>
  );
}
export function TableHeader({ className, children }) {
  return <thead className={cn('[&_tr]:border-b [&_tr]:border-line', className)}>{children}</thead>;
}
export function TableBody({ className, children }) {
  return <tbody className={cn('[&_tr:last-child]:border-0', className)}>{children}</tbody>;
}
export function TableRow({ className, children, onClick }) {
  return (
    <tr onClick={onClick} className={cn(
      'border-b border-line transition-colors',
      onClick ? 'cursor-pointer hover:bg-sunken' : 'hover:bg-sunken/60',
      className
    )}>{children}</tr>
  );
}
export function TableHead({ className, children }) {
  return <th className={cn('h-9 px-3 text-left align-middle text-[11px] font-semibold text-faint uppercase tracking-wider', className)}>{children}</th>;
}
export function TableCell({ className, children }) {
  return <td className={cn('px-3 py-2.5 align-middle text-sm text-body', className)}>{children}</td>;
}
